// The shared-password sign-in screen's logo when the store has none.
//
// One definition for both places that draw that screen: the storefront
// sign-in (StorefrontSignIn.vue) and the Store Login editor's preview
// (StoreShopper.vue), so the preview cannot drift from what shoppers see.
//
// Bug Intake #395: the storefront used /static/images/facebook_thumbnail.png,
// a 381x200 social-share image whose wordmark is already cut at both edges,
// drawn with object-fit: cover into a 350x350 square -- shoppers saw "eadF".
// This is the full wordmark the ThreadFlow auth pages use; callers draw it
// FITTED (contain), never covered.
import fullWordmark from "@/assets/logo/logo_big.png";

export const DEFAULT_SIGN_IN_LOGO_SRC = fullWordmark;

// Legacy sentinel some stores carry in ``storefront_login_image`` meaning
// "no logo uploaded". It names a frontend asset, never an uploaded image, so
// it must not be resolved through the image bucket (it 404s there).
export const SIGN_IN_NO_LOGO_SENTINEL = "storefront_login_preview_image.png";
